import {ZkUserGroup} from './ZkUserGroup';
import {ZkPrivilege} from './ZkPrivilege';

export class ZkUser {
  id: number;
  group: ZkUserGroup;
  cardNumber: number;
  badgeNumber: string;
  pinCode: string;
  startDate: Date;
  endDate: Date;
  name: string;
  privilege: ZkPrivilege;
  disabled: boolean;
  authorizeTimezoneId: number;
  authorizeDoorId: number;

  public constructor(init?: Partial<ZkUser>) {
    Object.assign(this, init);
  }
}
